import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-ml",
  "use": "icon-icon-ml-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-ml\">\n  <g fill-rule=\"evenodd\">\n    <path fill=\"red\" d=\"M340.6 0H512v512H340.6z\" />\n    <path fill=\"#009a00\" d=\"M0 0h170.3v512H0z\" />\n    <path fill=\"#ff0\" d=\"M170.3 0h171.2v512H170.3z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol